import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bt-icon bt-icon--sm" }
const _hoisted_2 = { class: "dialog-custom__footer" }
const _hoisted_3 = {
  key: 3,
  class: "app-loader app-loader--contextual"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_WizardPlantTypeSelection = _resolveComponent("WizardPlantTypeSelection")
  const _component_WizardAutomationPlant = _resolveComponent("WizardAutomationPlant")
  const _component_WizardEntrancePlant = _resolveComponent("WizardEntrancePlant")
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isDialogVisible = $event)),
    showHeader: false,
    modal: true,
    onHide: _ctx.doHideDialog,
    class: "dialog-custom dialog-plant-create"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "close",
        onClick: _ctx.handleHideDialog,
        class: "dialog-custom__close-button p-button-text"
      }, {
        default: _withCtx(() => [
          _createVNode("span", _hoisted_1, [
            _createVNode(_component_InlineSvgScoped, {
              src: require(`@/assets/images/icons/icon-close.svg`)
            }, null, 8, ["src"])
          ])
        ]),
        _: 1
      }, 8, ["onClick"]),
      (_ctx.plantCreateSteps == _ctx.PlantCreateSteps.TYPE_SELECTION)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_WizardPlantTypeSelection, {
              plantType: _ctx.selectedPlantType,
              "onUpdate:plantType": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedPlantType = $event)),
              residentialType: _ctx.selectedResidentialType,
              "onUpdate:residentialType": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedResidentialType = $event))
            }, null, 8, ["plantType", "residentialType"]),
            _createVNode("footer", _hoisted_2, [
              _createVNode(_component_Button, {
                onClick: _ctx.handleContinueButton,
                label: _ctx.$t('AppResource.Continue'),
                class: "p-button-rounded p-button-raised p-button--m"
              }, null, 8, ["onClick", "label"])
            ])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.plantCreateSteps == _ctx.PlantCreateSteps.WIZARD_AUTOMATION)
        ? (_openBlock(), _createBlock(_component_WizardAutomationPlant, {
            key: 1,
            plantId: _ctx.localPlantId,
            onUpdate: _ctx.updateId,
            onPlantEdited: _ctx.onPlantEdited,
            onExitWizard: _cache[3] || (_cache[3] = ($event: any) => (_ctx.plantCreateSteps = _ctx.PlantCreateSteps.TYPE_SELECTION))
          }, null, 8, ["plantId", "onUpdate", "onPlantEdited"]))
        : _createCommentVNode("", true),
      (_ctx.plantCreateSteps == _ctx.PlantCreateSteps.WIZARD_ENTRANCE)
        ? (_openBlock(), _createBlock(_component_WizardEntrancePlant, {
            key: 2,
            plantId: _ctx.localPlantId,
            isEdit: _ctx.isEdit,
            onUpdate: _ctx.updateId,
            onPlantEdited: _ctx.onPlantEdited,
            onExitWizard: _cache[4] || (_cache[4] = ($event: any) => (_ctx.plantCreateSteps = _ctx.PlantCreateSteps.TYPE_SELECTION))
          }, null, 8, ["plantId", "isEdit", "onUpdate", "onPlantEdited"]))
        : _createCommentVNode("", true),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode(_component_ProgressSpinner)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}